import {Component} from '@angular/core';
import {LogoutPositionEnum} from '@core/modules/authentication/components/logout/config/logout-position.enum';
import {BootstrapLicenseDataService} from '@core/services';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent {
  public readonly LogoutPosition = LogoutPositionEnum;

  constructor(public bootstrapLicenseData: BootstrapLicenseDataService) { }
}
